import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../service";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { DailyRouteSummaryWithGainAndLossReportSchemaObject } from "../dailyRouteSummaryWithGainAndLossReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import { TableRow, Card, Container } from "@material-ui/core";
import Chip from '@mui/material/Chip';

const screenCode = "DAILYROUTESUMMARYWITHGAINANDLOSSREPORT";
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function DailyRouteSummaryWithGainAndLossReport(props) {
    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [factoryTotal, setFactoryTotal] = useState(0);
    const [routeTotal, setRouteTotal] = useState(0);
    const [gainLossTotal, setGainLossTotal] = useState(0);

    const [dailyRouteSummary, setDailyRouteSummary] = useState({
        groupID: 0,
        estateID: "0",
        month: "",
        routeID: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: 0,
        estateID: "0",
        month: "",
        routeID: "0"
    })

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);
    const [reportData, setReportData] = useState([]);
    const [routes, setRoutes] = useState([]);


    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown(),
        );
    }, []);
    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [dailyRouteSummary.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
            getRoutesForDropDown()
        )
    }, [dailyRouteSummary.estateID])


    function clearTable() {
        setIsTableHide(true);
        setIsReportButtonsEnabled(false);
        setReportData([]);
        setDailyRouteSummary({
            groupID: 0,
            estateID: "0",
            month: "",
            routeID: "0"
        })
    }

    function handleGroupChange(target) {
        validateInputs(target);
        setDailyRouteSummary({
            ...dailyRouteSummary,
            groupID: target.value,
            estateID: "0",
            routeID: "0"
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);
        setDailyRouteSummary({
            ...dailyRouteSummary,
            estateID: target.value,
            routeID: "0"
        });
    }

    function handleRouteChange(target) {
        setDailyRouteSummary({
            ...dailyRouteSummary,
            routeID: target.value
        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);
        setDailyRouteSummary({
            ...dailyRouteSummary,
            month: target.value
        });
    }
    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyRouteSummaryWithGainAndLossReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];
        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYROUTESUMMARYWITHGAINANDLOSSREPORT');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();
        setDailyRouteSummary({
            ...dailyRouteSummary,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(dailyRouteSummary.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(dailyRouteSummary.estateID);
        setDivisions(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(dailyRouteSummary.estateID);
        setRoutes(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function getdata(e) {
        e.preventDefault();
        setIsTableHide(true);
        setButtonHide(true);
        getSelectedDropdownValuesForReport(dailyRouteSummary);
        setIsTableHide(true);

        var model = {
            groupID: parseInt(dailyRouteSummary.groupID),
            estateID: parseInt(dailyRouteSummary.estateID),
            routeID: parseInt(dailyRouteSummary.routeID),
            month: dailyRouteSummary.month
        }
        const factoryDetails = await services.GetFactoryDetailsForReport(model);
        const routeDetails = await services.GetRouteDetailsForReport(model);
        var copyRouteDetails = _.cloneDeep(routeDetails);
        var LfList = copyRouteDetails.filter(x => x.transactionTypeCode == 'LF')
        var RetList = copyRouteDetails.filter(x => x.transactionTypeCode == 'RET')
        LfList.forEach(x => {
            var res = RetList.find(y => y.date.split('T')[0] == x.date.split('T')[0])
            if (res) {
                x.totalAmount = x.totalAmount - res.totalAmount
            }
        })
        FormatData(factoryDetails, LfList);
    }

    function FormatData(factoryData, routeData) {
        let monthValue = dailyRouteSummary.month;
        const month = monthValue.split('-')[1];
        const year = monthValue.split('-')[0];

        function getDaysInMonth(year, month) {
            return new Date(year, month, 0).getDate();
        }
        const value = getDaysInMonth(year, month);
        let dateArray = [];
        for (let i = 1; i <= value; i++) {
            dateArray.push(i);
        }

        const newArray = [];
        factoryData.forEach(x => {
            const date = new Date(x.date);
            const day = date.getDate();
            newArray.push({
                date: day,
                netQuantity: x.netAmount,
                longDate: x.date.split('T')[0]
            });
        })

        const missingDates = dateArray.filter(date => !newArray.some(item => item.date === date));
        missingDates.forEach((day) => {
            if (day < 10) {
                newArray.push({
                    date: day,
                    netQuantity: 0,
                    longDate: `${year}-${month}-0${day}`
                });
            } else {
                newArray.push({
                    date: day,
                    netQuantity: 0,
                    longDate: `${year}-${month}-${day}`
                });
            }

        });

        newArray.forEach((x) => {
            const matchingRouteData = routeData.find((y) => {
                const date = new Date(y.date);
                const day = date.getDate();
                return x.date === day;
            });


            if (matchingRouteData) {
                x.totalAmount = matchingRouteData.totalAmount;
            } else {
                x.totalAmount = 0;
            }
        });

        newArray.forEach(x => {
            x.gain = x.netQuantity - x.totalAmount
            if (x.gain < 0) {
                x.term = "Loss"
            } else if (x.gain == 0) {
                x.term = "-"
            } else {
                x.term = "Gain"
            }
        })

        newArray.sort((a, b) => a.date - b.date);
        setReportData(newArray);

        let RouteTotal = 0;
        let FactoryTotal = 0;
        let GainLossTotal = 0;
        newArray.forEach(x => {
            RouteTotal += x.totalAmount
            FactoryTotal += x.netQuantity
            GainLossTotal += x.gain
        });
        setRouteTotal(RouteTotal);
        setFactoryTotal(FactoryTotal);
        setGainLossTotal(GainLossTotal);
    }

    function createFile() {
        var settings = {
            sheetName: ' DRS report',
            fileName: 'DRS Report',
            writeOptions: {}
        }
        let csvHeaders = [];
        csvHeaders.push(
            { label: "Date", value: "longDate" },
            { label: "Route (Kg)", value: "totalAmount" },
            { label: "Factory (Kg)", value: "netQuantity" },
            { label: "G/L (Kg)", value: "gain" },
            { label: "G/L", value: "term" }
        );

        var copyOfCsv = [...reportData]

        var newRow = {
            longDate: "Group :" + groups[dailyRouteSummary.groupID],
            totalAmount: "Estate : " + estates[dailyRouteSummary.estateID],
            netQuantity: "Division : " + divisions[dailyRouteSummary.routeID],
            gain: "Month : " + dailyRouteSummary.month
        }

        copyOfCsv.push({}, {}, newRow);
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.routeID],
            month: searchForm.month
        })
    }

    return (

        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">

                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Daily Route Summary with Gain & Loss Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={dailyRouteSummary.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID"> Fcatory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={dailyRouteSummary.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="routeID">Route </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={dailyRouteSummary.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">-- Select Route --</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="month">Month *</InputLabel>
                                        <TextField
                                            fullWidth
                                            placeholder="-- Select Month --"
                                            id="month"
                                            name="month"
                                            type="month"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["month"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(getdata(e))}
                                    />
                                    <input type="reset" className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={clearTable}
                                    />
                                </div>
                                <br />
                                {reportData.length > 0 ?
                                    <div className="form-group row">
                                        <div className="col-md-12 pb-1">
                                            <Container>
                                                <Card style={{ justifycontent: 'center' }}>
                                                    <Paper className={classes.paper}>
                                                        <TableContainer>
                                                            <Table aria-label="simple table">
                                                                <TableHead>
                                                                    <TableRow style={{ border: "2px solid black" }}>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Date</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Route (Kg)</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Factory (Kg)</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Gain or Loss (Kg)</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Gain or Loss</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {reportData.map((rows, i) => {
                                                                        const result = rows.gain;
                                                                        return (
                                                                            < TableRow key={i}
                                                                                style={{ border: "2px solid black" }}>
                                                                                <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", fontWeight: "bold" }}> {rows.longDate}</TableCell>
                                                                                <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", fontWeight: "bold" }}> {rows.totalAmount == 0 ? parseFloat(rows.totalAmount) : parseFloat(rows.totalAmount).toFixed(2)}</TableCell>
                                                                                <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", fontWeight: "bold" }}> {rows.netQuantity == 0 ? parseFloat(rows.netQuantity) : parseFloat(rows.netQuantity).toFixed(2)}</TableCell>
                                                                                <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", fontWeight: "bold" }}> {rows.gain == 0 ? parseFloat(rows.gain) : parseFloat(rows.gain).toFixed(2)}</TableCell>
                                                                                {rows.gain < 0 ?
                                                                                    <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>
                                                                                        <Chip label={rows.term} style={{ borderColor: "#ffccd0", backgroundColor: "#ffccd0" }} />
                                                                                    </TableCell>
                                                                                    : rows.gain > 0 ?
                                                                                        <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>
                                                                                            <Chip label={rows.term} style={{ borderColor: "#c4eabf", backgroundColor: "#c4eabf" }} />
                                                                                        </TableCell> :
                                                                                        <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>
                                                                                            {rows.term}
                                                                                        </TableCell>}
                                                                            </TableRow>
                                                                        )
                                                                    })}
                                                                    <TableRow style={{ border: "2px solid black" }}>
                                                                        <TableCell component="th" style={{ fontWeight: "bold" }} scope="row" align="center"> Total</TableCell>
                                                                        <TableCell component="th" scope="row" style={{ border: "2px solid black", fontWeight: "bold" }} align="center">{routeTotal == 0 ? parseFloat(routeTotal) : parseFloat(routeTotal).toFixed(2)}</TableCell>
                                                                        <TableCell component="th" scope="row" style={{ border: "2px solid black", fontWeight: "bold" }} align="center">{factoryTotal == 0 ? parseFloat(factoryTotal) : parseFloat(factoryTotal).toFixed(2)}</TableCell>
                                                                        <TableCell component="th" scope="row" style={{ border: "2px solid black", fontWeight: "bold" }} align="center">{gainLossTotal == 0 ? parseFloat(gainLossTotal) : parseFloat(gainLossTotal).toFixed(2)}</TableCell>
                                                                        {gainLossTotal < 0 ?
                                                                            <TableCell component="th" scope="row" style={{ border: "2px solid black", fontWeight: "bold" }} align="center">
                                                                                <Chip label={"Loss"} style={{ backgroundColor: "#ffccd0", fontWeight: "bolder" }} /></TableCell>
                                                                            : gainLossTotal > 0 ?
                                                                                <TableCell component="th" scope="row" style={{ border: "2px solid black", fontWeight: "bold" }} align="center">
                                                                                    <Chip label={"Gain"} style={{ backgroundColor: "#c4eabf", fontWeight: "bolder" }} /> </TableCell>
                                                                                :
                                                                                <TableCell component="th" scope="row" style={{ border: "2px solid black", fontWeight: "bold" }} align="center">-</TableCell>
                                                                        }
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Paper>
                                                </Card>
                                            </Container>
                                        </div>
                                    </div>
                                    : null}
                            </form>
                            {reportData.length > 0 ?
                                <div>
                                    <br />
                                    <>
                                        <div className="pt-2" justify-content="center" >
                                            <input
                                                type="button"
                                                className="btn btn-primary pull-right ml-2"
                                                value="Excel"
                                                onClick={createFile}
                                            />
                                            <ReactToPrint
                                                documentTitle={"Daily Route Summary with Gain & Loss Report"}
                                                trigger={() => <input
                                                    type="submit"
                                                    className="btn btn-primary pull-right ml-2"
                                                    value="PDF"
                                                />}
                                                content={() => componentRef.current}
                                            />
                                        </div>
                                        <div hidden={true}>
                                            <CreatePdf ref={componentRef}
                                                data={reportData}
                                                routeTotal={routeTotal}
                                                factoryTotal={factoryTotal}
                                                searchData={selectedSearchValues}
                                                gainLossTotal={gainLossTotal}
                                            />
                                        </div>
                                    </>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div >
        </Fragment >
    );
}
